import { formatDate } from '@angular/common';
import { Component } from '@angular/core';

import {
  AdvancedFilterModel,
  DateAdvancedFilterModel,
  IFilterParams,
  JoinAdvancedFilterModel,
} from 'ag-grid-enterprise';

import { DatePickerComponent } from '@camelot/form-input';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';

import { ActiveFilterTag } from '../../../../filters/types';
import { BaseFilterComponent, operatorMap } from '../base-col';
import type { DateCol } from './date-col';

@Component({
  host: { 'data-cid': 'date-filter' },
  imports: [DatePickerComponent, TextComponent, TranslatePipe],
  styleUrls: ['../filter.scss'],
  template: `
    @if (this.input) {
      <div>
        <div class="filter-title">
          <cam-text [isBold]="true" size="sm" color="brand-primary">{{ this.filterTitle() | translate }}</cam-text>
        </div>
        <div class="p-space-sm">
          <cam-input-date-picker
            [input]="$any(this.input)"
            [standalone]="true"
            (valueChanged)="this.applyInputValue($event)"
          ></cam-input-date-picker>
        </div>
      </div>
    }
  `,
})
export class DateFilterComponent extends BaseFilterComponent<
  JoinAdvancedFilterModel | DateAdvancedFilterModel,
  DateCol
> {
  override agInit(params: IFilterParams) {
    super.agInit(params);
  }

  override getTags(model?: AdvancedFilterModel | null): ActiveFilterTag[] {
    if (!model) {
      model = this._model;
    }
    if (!model) {
      return [];
    }
    if (model.filterType === 'date') {
      if (model.filter === undefined) {
        return [];
      }

      const operator = operatorMap[model.type] || model.type;

      return [
        {
          condition: model,
          id: model.colId,
          name: `${operator} ${formatDate(model.filter, 'shortDate', 'fr')}`,
        },
      ];
    }
    if (model.filterType === 'join') {
      return model.conditions.flatMap(condition => this.getTags(condition));
    }

    return [];
  }
}
